import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";
import type { ContractPaymentsListRow } from "@/admin/entities/contractPayments";
import { formatDay } from "./billingFormat";

/**
 * Колонка номера инвойса отдельным файлом от остальных колонок платежа:
 * ссылка на файл открывается в новой вкладке напрямую по invoiceUrl, как
 * подписанные ссылки в разделе соответствия партнёрского кабинета, без
 * скачивания через запрос и объект в памяти.
 */
export function buildInvoiceNumberColumn(): ColumnDefinition<ContractPaymentsListRow> {
  return {
    name: "invoiceNumber",
    label: "Номер инвойса",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const payment = data as ContractPaymentsListRow;
        if (!payment.invoice || !payment.invoiceUrl) return "-";
        const previousNumbers = payment.invoice.previousNumbers;
        return (
          <Stack spacing={0.25}>
            <Link
              href={payment.invoiceUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {payment.invoice.number}
            </Link>
            {/* История перевыставлений запрашивается, но нигде не была
                видна (финальное ревью L2): без неё непонятно, что номер
                уже не первый и клиенту раньше уходил другой счёт. */}
            {previousNumbers.length > 0 && (
              <Tooltip
                title={previousNumbers
                  .map(
                    (item) =>
                      `№${item.number} от ${formatDay(item.issuedAt)}: ${item.reason}`
                  )
                  .join("; ")}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ cursor: "help", textDecoration: "underline dotted" }}
                >
                  Перевыставлений: {previousNumbers.length}
                </Typography>
              </Tooltip>
            )}
          </Stack>
        );
      },
    },
  };
}
